// srt-loader.js — Dev UI tool for loading predefined test cases into the form

import { updateSprungTareMass, updateDefaultAdvancedFields } from './srt-load.js';
import { updateFormForVehicleType } from './srt-vehicle.js';
import { updateAllPayloads } from './srt-tare-gross.js';

export function initFileLoader() {
   $('#test-file-loader').val('');
   $('#test-file-loader').on('change', function () {
      const file = this.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = function (event) {
         try {
            const json = JSON.parse(event.target.result);
            if (!json || typeof json !== 'object' || !json.values) {
               alert('Invalid test case format.');
               return;
            }

            loadTestCaseIntoForm(json);
         } catch (e) {
            console.error('Error parsing test case file:', e);
            alert('Failed to parse test case file. Ensure it is valid JSON.');
         }
      };

      reader.readAsText(file);
   });
}

function loadTestCaseIntoForm(test, unitIndex = 0) {
   console.log(`Loading test case: ${test.name || 'Unnamed Test'}`);
   $(`results-messages-${unitIndex}`).empty().hide();

   // update form layout, selects and presets based on the vehicle type
   const vt = test.values.vehicleType;
   updateFormForVehicleType(vt, unitIndex);

   // Expand all accordion sections for the current unit
   $(`#accordion-${unitIndex} .accordion-collapse`).each(function () {
      const $section = $(this);
      const $button = $section.prev('.accordion-header').find('button');

      // Expand if not already shown
      if (!$section.hasClass('show')) {
         $button.removeClass('collapsed');
         $section.addClass('show');
      }
   });

   // Set the suspension-type-rear suspension-type-front selects to 'user' in all cases since we are loading suspension values
   const $selFront = $(`#suspension-type-front-${unitIndex}`);
   const $selRear = $(`#suspension-type-rear-${unitIndex}`);
   $selFront.val('user').trigger('change');
   $selRear.val('user').trigger('change');

   // Set each field value in the test case, including suspension advanced values
   Object.entries(test.values).forEach(([key, value]) => {
      // don't set the vehicle type, suspension type
      if (key === 'vehicleType' || key === 'suspensionTypeFront' || key === 'suspensionTypeRear') {
         return;
      }
      const $field = $(`[data-field="${key}"]`);
      if ($field.length > 0) {
         const currentValue = $field.val();
         const normalizedCurrent = (currentValue ?? '').toString();
         const normalizedNew = (value ?? '').toString();

         // Only update and highlight if value is different
         if (normalizedCurrent !== normalizedNew) {
            $field.val(value).trigger('change');
            highlightFieldTemporary($field);
         }
      } else {
         console.warn(`Missing field: ${key}`);
      }
   });

   // After fields are populated, trigger any dependent recalculation manually
   updateAllPayloads(unitIndex);
   updateDefaultAdvancedFields('f', unitIndex);
   updateDefaultAdvancedFields('r', unitIndex);
   updateSprungTareMass(unitIndex);

   // Hook up post-calculate result comparison
   if (typeof test.srtExpected === 'number') {
      $(`#calculate-srt-${unitIndex}`).one('click', () => {
         setTimeout(() => checkSRTAgainstExpected(unitIndex, test.srtExpected), 100);
      });
   }
}

function highlightFieldTemporary($el, className = 'border border-warning', duration = 5000) {
   if (!$el || $el.length === 0) return;
   $el.addClass(className);

   setTimeout(() => {
      $el.removeClass(className);
   }, duration);
}

function checkSRTAgainstExpected(unitIndex, expected) {
   const actual = parseFloat($(`#srt-result-${unitIndex}`).text());
   if (!Number.isFinite(actual)) return;
   const delta = Math.abs(expected - actual);
   const $badge = $(`#srt-result-badge-${unitIndex}`);
   $badge.removeClass('bg-success bg-danger');
   if (delta < 0.01) {
      $badge.addClass('bg-success').text('Match');
   } else {
      $badge.addClass('bg-danger').text(`Δ=${delta.toFixed(3)}`);
   }
}
